import {Button} from '@guestapp/ui';
import {device} from 'styled/device';
import styled from 'styled-components';

export const RadiosContent = styled.div`
  & .multi-radio {
    gap: 16px;
    margin-bottom: 48px;
  }

  & .multi-radio__option {
    border-radius: 12px;
    border: 1px solid
      ${({theme}) =>
        theme.hasTemplate ? theme.colors.branding.backgroundMain : 'rgba(0, 0, 0, 0.1)'};
    background: ${({theme}) =>
      theme.hasTemplate ? theme.colors.branding.boxesModals : '#fff'};

    padding: 16px;
    align-items: center;
    gap: 16px;
    align-self: stretch;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.07);
    max-width: 327px;
    margin: 0 auto;
    width: 100%;

    & .multi-radio__label {
      color: ${({theme}) => theme.colors.branding.fontPrimary};
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      &:before {
        margin-right: 1em;
      }
    }

    @media (min-width: ${device.tablet}) {
      max-width: 327px;
      margin: 0 auto;
    }
  }
`;

export const StyledButton = styled(Button)`
  margin: 0 auto;
  width: 100%;
  max-width: 327px;
`;

export const Wrapper = styled.div<{$disabled?: boolean}>`
  opacity: ${({$disabled}) => ($disabled ? 0.5 : 1)};
  pointer-events: ${({$disabled}) => ($disabled ? 'none' : 'auto')};
  transition: opacity 0.3s ease-in-out;

  @media (min-width: ${device.tablet}) {
    padding-bottom: 40px;
  }
`;
